module.exports = __webpack_public_path__ + "img/add-attendance.cd7a3c87.svg";